module.exports = __webpack_public_path__ + "img/amb_bg2.e38b29b1.png";